export class UserModel {
  public cssId: number;
  public evaluator: string;
  public brse: string;
  public customerName: string;
  public projectManagerName: string;
  public projectName: string;
  public sendDate: string;
  public responseDate: string;
  public lang: string;
  public expectedCountDown: number;

  constructor(css: {
    cssId: number;
    evaluator: string;
    brse: string;
    customerName: string;
    projectManagerName: string;
    projectName: string;
    sendDate: string;
    responseDate: string;
    lang: string;
    expectedCountDown: number;
  }) {
    this.cssId = css.cssId;
    this.evaluator = css.evaluator;
    this.brse = css.brse;
    this.customerName = css.customerName;
    this.projectManagerName = css.projectManagerName;
    this.projectName = css.projectName;
    this.sendDate = css.sendDate;
    this.responseDate = css.responseDate;
    this.lang = css.lang;
    this.expectedCountDown = css.expectedCountDown;
  }
}
